module.exports = require("./assets");


//////////////////
// WEBPACK FOOTER
// external "./assets"
// module id = 70
// module chunks = 0